import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { NavBarContainer } from '../containers/NavBar.container';

import { AppHeaderContainer } from './AppHeader.container';

import '../style/global.css';

const useStyle = makeStyles((theme) => {
  return {
    layout: {
      // @ts-ignore
      backgroundColor: theme.palette.background.semilight,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      '& .app-header': {
        flex: '0 0 var(--size-app-header-height)',
        zIndex: '2000',
      },
    },
    layoutContent: {
      display: 'flex',
      flex: '1 1 auto',
      overflow: 'hidden',
      color: theme.palette.text.primary,
    },
    content: {
      display: 'flex',
      flex: '1 1 auto',
      overflow: 'hidden',
    },
  };
});

export const MainLayoutContainer: React.FC<{
  children?: React.ReactNode;
  displayNavBar?: boolean;
  location?: any;
}> = ({ children, displayNavBar, location }) => {
  const classes = useStyle();

  return (
    <div className={classes.layout}>
      <AppHeaderContainer />
      <div className={classes.layoutContent}>
        {/* @ts-ignore */}
        {displayNavBar && <NavBarContainer location={location} />}
        <section className={classes.content} id="app-content">
          {children}
        </section>
      </div>
    </div>
  );
};
